// chessground als snabbdom-Knoten: das Brett wird einmal erzeugt und danach nur umgestellt.
import { Chessground } from '@lichess-org/chessground';
import type { Api } from '@lichess-org/chessground/api';
import type { Config } from '@lichess-org/chessground/config';
import type { Key } from '@lichess-org/chessground/types';
import { h, type VNode } from 'snabbdom';
import type { Ply } from './api';

export function board(key: string, config: Config, onReady?: (api: Api, el: HTMLElement) => void): VNode {
  return h('div.cg-wrap-host', {
    key,
    hook: {
      insert: vnode => {
        const api = Chessground(vnode.elm as HTMLElement, config);
        (vnode.elm as any).cg = api;
        onReady?.(api, vnode.elm as HTMLElement);
      },
      postpatch: (_, vnode) => {
        const api: Api | undefined = (vnode.elm as any).cg;
        api?.set(config);
      },
      destroy: vnode => (vnode.elm as any).cg?.destroy(),
    },
  });
}

/** Stellung eines Halbzugs als chessground-Konfiguration. */
export function plyConfig(p: Ply): Config {
  const turn = p.fen.split(' ')[1] === 'b' ? 'black' : 'white';
  const check = !!p.san && /[+#]$/.test(p.san);
  const lastMove = p.last ? ([p.last.slice(0, 2), p.last.slice(2, 4)] as Key[]) : undefined;
  return { fen: p.fen, turnColor: turn, check: check ? turn : false, lastMove };
}
